<template>
  <div>
    <navigationFab />
    <v-img
      src="https://images.unsplash.com/photo-1502773860571-211a597d6e4b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="94vh"
    >
      <div class="centered">
        <div class="mt-16">
          <v-row>
            <v-col class="d-flex justify-center">
              <span class="primary--text text-sm-h2 text-h4 font-weight-bold"
                >Successfully Listified!</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-center pb-0">
              <span
                v-if="this.$globalState.listifyInfo.createHistory"
                class="text-sm-h5 text-h6"
                >Copied
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.curPlaylistName
                }}</span>
                to
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.hisPlaylistName
                }}</span></span
              >
            </v-col>
          </v-row>
          <v-row v-if="this.$globalState.listifyInfo.allAddAmount > 0">
            <v-col class="d-flex justify-center py-0">
              <span class="text-sm-h5 text-h6"
                >Added
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.allAddAmount
                }}</span>
                new song<span
                  v-if="this.$globalState.listifyInfo.allAddAmount > 1"
                  >s</span
                >
                to
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.allPlaylistName
                }}</span></span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-center py-0">
              <span
                v-if="this.$globalState.listify.curPlaylistBehavior === 'clear'"
                class="text-sm-h5 text-h6"
                >Cleared
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.curPlaylistName
                }}</span></span
              >
              <span
                v-if="
                  this.$globalState.listify.curPlaylistBehavior === 'edit' &&
                    this.$globalState.listifyInfo.curRemAmount > 0
                "
                class="text-sm-h5 text-h6"
                >Removed
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.curRemAmount
                }}</span>
                track<span v-if="this.$globalState.listifyInfo.curRemAmount > 1"
                  >s</span
                >
                from
                <span class="primary--text">{{
                  this.$globalState.listifyInfo.curPlaylistName
                }}</span></span
              >
            </v-col>
          </v-row>
          <v-row class="pt-6">
            <v-col class="d-flex justify-center">
              <v-btn color="primary" to="/" class="mr-6">Home</v-btn>

              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-clipboard:copy="shareLink"
                    @click="notifyCopy"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary">mdi-share-variant-outline</v-icon>
                  </v-btn>
                </template>
                <span>Share Listify with your Friends :)</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-img>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
export default {
  name: "Listified",
  title: "Successfully Listified!",
  components: {
    navigationFab,
  },
  data() {
    return {
      shareLink:
        this.$siteUrl +
        "?ref=" +
        this.$globalState.userRef.replace("spotify:user:", ""),
    };
  },
  methods: {
    notifyCopy: function() {
      let Notify = {
        duration: 4000,
        type: "success",
        headline: "Successfully copied Link",
        message: "Thanks for sharing Listify :)",
      };
      this.$globalState.addNotification(Notify);
    },
  },
};
</script>

<style scoped>
.v-centered {
  display: grid;
  place-items: center end;
}

.remaining-height {
  height: 70vh;
}
.centered {
  display: grid;
  place-items: center stretch;
  height: 94vh;
}
</style>
